import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e2953498&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e2953498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2953498",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2953498')) {
      api.createRecord('e2953498', component.options)
    } else {
      api.reload('e2953498', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e2953498&scoped=true&", function () {
      api.rerender('e2953498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28LdKzJa255hE/JS/comp/SearchFilterTokens.vue"
export default component.exports